module.exports = __webpack_public_path__ + "img/main_logo_icon.9748bef1.png";